var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.columnData),function(link,index){return _c('div',{key:index},[(typeof link.to !== 'undefined')?[_c('router-link',{attrs:{"to":link.to}},[_vm._v(_vm._s(link.label))])]:[_vm._v(" "+_vm._s(link)+" ")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }